<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div
      class="
        modal-dialog
        modal-dialog-centered
        modal-xl
        modal-xxl
        modal-dialog-scrollable
      "
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row w-100">
            <div class="col-4 text-start">
              <h5 class="modal-title" id="staticBackdropLabel">{{ name }}</h5>
            </div>
            <div class="col-3">
              <input
                type="text"
                class="form-control"
                v-model="q"
                placeholder="Search"
              />
            </div>
            <div class="col-1">
              <select v-model="isLocked" class="form-control">
                <option value="">All status</option>
                <option :value="0">Not locked</option>
                <option :value="1">Locked</option>
              </select>
            </div>
            <div class="col-2">
              <v-select
                :options="products"
                v-model="selectedProduct"
                placeholder="Product"
              />
            </div>
            <div class="col-2">
              <v-select
                :options="categories"
                v-model="selectedCategory"
                placeholder="Category"
              />
            </div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`addNewContactsModal.close`)"
            v-on:click="$emit('update:show', false)"
          ></button>
        </div>
        <div class="modal-body max-width-rows">
          <DynamicTable
            v-model:rows="rows"
            v-model:items="filteredItems"
            :fix-height="false"
            :show-order="false"
            :show-pin="false"
            v-on:update:val="valUpdated"
            type="operations"
            :key="tableKey"
          />
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
import DynamicTable from "../lists/DynamicTable";
import { useStore } from "vuex";
import tenant from "../../modules/tenant";
const bootstrap = require("bootstrap");

export default {
  name: "ProductManufacturingOperationsModal",
  props: {
    modelValue: Object,
    show: Boolean,
    operation: Number,
  },
  emits: ["update:modelValue", "update:show"],
  data: function () {
    return {
      store: useStore(),
      loadAddBtn: false,
      q: "",
      selectedProduct: null,
      selectedCategory: null,
      isLocked: "",
      tableKey: 0,
      name: "",
      rows: [
        {
          name: "Operation",
          key: "manufacturing_operation_id",
          type: "enum",
          label: "name",
          selectKey: "id",
          values: [],
          editable: true,
          show: true,
        },
        {
          name: "Step",
          key: "order",
          type: "number",
          show: true,
          editable: false,
        },
        {
          name: "Image",
          key: "image",
          type: "image",
          show: true,
          editable: false,
        },
        {
          name: "Serial",
          key: "serial",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Time",
          key: "time",
          type: "number",
          show: true,
          editable: true,
        },
        {
          name: "Description",
          key: "description",
          type: "string",
          show: true,
          editable: true,
        },
        {
          name: "Extra info",
          key: "extra_info",
          type: "string",
          show: true,
          editable: true,
        },
      ],
      items: undefined,
      myModal: null,
    };
  },
  mounted() {
    this.myModal = new bootstrap.Modal(this.$refs.modal, {
      backdrop: "static",
    });
    if (this.show) {
      this.load();
      this.myModal.show();
    } else {
      this.myModal.hide();
    }
    const _this = this;
    this.$refs.modal.addEventListener("hidden.bs.modal", function () {
      _this.$emit("update:show", false);
    });
  },
  watch: {
    show() {
      if (this.show) {
        this.load();
        this.myModal.show();
      } else {
        this.myModal.hide();
      }
    },
    filteredItems() {
      this.tableKey++;
    },
  },
  computed: {
    mediaServer() {
      return tenant.getAppMediaUrl();
    },
    warehouse() {
      return this.store.state.topBar.warehouse;
    },
    operations() {
      return this.store.state.operations;
    },
    products() {
      return [...new Set((this.items || []).map((i) => i.serial))];
    },
    categories() {
      return [...new Set((this.items || []).map((i) => i.category_name))];
    },
    filteredItems() {
      return (
        this.items
          // Search filter
          .filter((item) => {
            if (!this.q || this.q.trim().length < 1) return true;
            return item.description
              ?.toLowerCase()
              .includes(this.q.toLowerCase());
          })

          // Product filter
          .filter((item) => {
            if (!this.selectedProduct) return true;
            return item.serial === this.selectedProduct;
          })

          // Category filter
          .filter((item) => {
            if (!this.selectedCategory) return true;
            return item.category_name === this.selectedCategory;
          })

          // Locked filter
          .filter((item) => {
            if (this.isLocked === null || this.isLocked === undefined)
              return true;
            if (this.isLocked === 0)
              return item.locked === 0 || item.locked === null;
            if (this.isLocked === 1) return item.locked === 1;
            return true;
          })
      );
    },
  },
  methods: {
    load() {
      http.fetch("/manufacturing/operations/" + this.operation).then((data) => {
        this.name = data.name;
        for (const row of data.data) {
          row.image =
            row.image !== null ? this.mediaServer + "/" + row.image : null;
        }
        this.items = data.data;
        this.rows[0].values = this.operations;
      });
    },
    valUpdated(val, row, id) {
      let rows = {};
      rows[row] = val;

      http.fetch("/manufacturing/operations/" + id, rows);
    },
  },
  components: { DynamicTable },
};
</script>
